import AppsIcon from '@mui/icons-material/Apps'
import EventIcon from '@mui/icons-material/Event'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import {
  Button,
  Chip,
  Menu,
  Stack,
  SxProps,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { FC, ReactNode, useContext, useMemo, useState } from 'react'
import { generatePath } from 'react-router-dom'

import FeedbackListButton from '../../components/Estimates/CustomerFeedback/FeedbackListButton'
import EmailPdfButton from '../../components/Estimates/EmailPdfButton'
import { PrintInvoiceButton } from '../../components/Estimates/PrintInvoiceButton'
import RepairOrderAttachmentButton from '../../components/Estimates/RepairOrderAttachment/RepairOrderAttachmentButton'
import RepairOrderMediaButton from '../../components/Estimates/RepairOrderMedia/RepairOrderMediaButton'
import ShareCustomerPortalButton from '../../components/Estimates/ShareCustomerPortalButton'
import { AppRoutes } from '../../models'
import { FeatureFlags } from '../../models/FeatureFlags'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'

export const EstimateDetailsButtons: FC = () => {
  const { featureFlags } = useContext(AppContext)
  const { customer, repairOrder, vehicle } = useContext(RepairOrderContext)

  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  const [anchorEl, setAnchorEl] = useState<
    HTMLAnchorElement | HTMLDivElement | null
  >()

  const isEstimate = useMemo(() => {
    return repairOrder ? repairOrder.entry!.info!.isEstimate : true
  }, [repairOrder])

  const renderActionButtons: (styles: SxProps) => ReactNode = (styles) => (
    <>
      <PrintInvoiceButton sx={styles} />
      <EmailPdfButton sx={styles} />
      <ShareCustomerPortalButton customer={customer} sx={styles} />
      {featureFlags && featureFlags[FeatureFlags.CustomerFeedbackMessaging] && (
        <FeedbackListButton sx={styles} />
      )}
      {repairOrder && (
        <RepairOrderMediaButton
          repairOrderId={repairOrder!.entry!.id!}
          sx={styles}
        />
      )}
      {repairOrder && (
        <RepairOrderAttachmentButton
          repairOrderId={repairOrder!.entry!.id!}
          sx={styles}
        />
      )}
      {repairOrder && !isEstimate && (
        <Button
          variant="text"
          startIcon={<EventIcon />}
          href={`${generatePath(AppRoutes.MANAGE_APPOINTMENTS, {
            id: 'new'
          })}?customerId=${customer?.id}&vehicleId=${
            vehicle?.id
          }&repairOrderId=${repairOrder!.entry?.id}`}
          sx={styles}>
          Add to Calendar
        </Button>
      )}
    </>
  )

  return (
    <>
      {isLargeScreen ? (
        <Stack direction="row" spacing={3}>
          {renderActionButtons({})}
        </Stack>
      ) : (
        <>
          <Chip
            icon={<AppsIcon />}
            label="Quick Actions"
            onClick={(e) => setAnchorEl(e.currentTarget)}
            onDelete={(e) => setAnchorEl(e.currentTarget)}
            deleteIcon={<KeyboardArrowDown />}
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}>
            <Stack direction="column">
              {renderActionButtons({ pl: 2, justifyContent: 'left' })}
            </Stack>
          </Menu>
        </>
      )}
    </>
  )
}
